import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { ThemeProvider } from './theme/ThemeContext';

import AdminLayout from './layout/AdminLayout';

// Pages
import DashboardPage from './admin/AdminDashboard';
import GuardsPage from './admin/GuardsPage';
import VisitsPage from './admin/VisitsPage';
import ScheduleRunsPage from './admin/ScheduleRunsPage';
import PropertiesPage from './admin/PropertiesPage';
import ReportsPage from './admin/ReportsPage';
import AdminLogin from './admin/adminLogin';
import AddClientForm from './admin/AddClientForm';
import ClientsPage from './admin/ClientsPage';
import AddPropertyForm from './admin/AddPropertyForm';
import ClientPortal from './clients/ClientsDashboard';
import AdminSuspended from './admin/AdminSuspended';
import ComingSoonPage from './components/FeaturesWork';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>

          {/* PUBLIC ROUTES (No Layout) */}
          <Route path="/" element={<AdminLogin />} />
          

          {/* PROTECTED ROUTES (WITH LAYOUT) */}
          <Route element={<AdminLayout />}>
          <Route path="/suspended" element={<AdminSuspended />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/schedule-runs" element={<ScheduleRunsPage />} />
            <Route path='/clients/add' element={<AddClientForm/>}/>
            <Route path='/clients' element={<ClientsPage/>}/>
            <Route path="/visits" element={<VisitsPage />} />
            <Route path="/guards" element={<GuardsPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/add" element={<AddPropertyForm/>}/>
            <Route path="/reports" element={<ReportsPage />} />
            <Route path='/featuresworks' element={<ComingSoonPage/>}/>

           
          </Route>

           <Route path="/clients/dashboard" element={<ClientPortal/>}/>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
